import React, { useState } from 'react';
import { Table, Form, Pagination, Button, Container, Modal } from 'react-bootstrap';
import './css/ManageCategory.css';
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";

const motherCategories = [
  { id: 1, name: 'Cleaning Service', logo: '', seoName: 'cleaning-service', status: 'Active' },
  { id: 2, name: 'Home Appliance Repair & Services', logo: '', seoName: 'home-appliance-repair-&-services', status: 'Active' },
  { id: 3, name: 'Beauty Care at Home', logo: '', seoName: 'beauty-care-at-home-', status: 'Deactive' },
  { id: 4, name: 'Health Care Services', logo: '', seoName: 'health-care-services', status: 'Active' },
  { id: 5, name: 'Pest Control Service', logo: '', seoName: 'pest-control-service', status: 'Active' },
];

const ITEMS_PER_PAGE = 10;

export default function MainCategory() {
  const [categories, setCategories] = useState(motherCategories);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false); // NEW
  const [selectedId, setSelectedId] = useState(null); // NEW
  const [newCategory, setNewCategory] = useState({ name: '', logo: null, seoName: '' });

  // --- Filter + Pagination ---
  const filteredCategories = categories.filter(cat =>
    cat.name.toLowerCase().includes(search.toLowerCase()) ||
    cat.seoName.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredCategories.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentCategories = filteredCategories.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  // --- Modal Control ---
  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setNewCategory({ name: '', logo: null, seoName: '' });
    setSelectedId(null);
  };

  const handleShow = () => {
    setEditMode(false);
    setShowModal(true);
  };

  // --- Input Change ---
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'logo') {
      setNewCategory({ ...newCategory, logo: files[0] });
    } else {
      setNewCategory({ ...newCategory, [name]: value });
    }
  };

  // --- Add New Category ---
  const handleAddCategory = () => {
    if (!newCategory.name || !newCategory.seoName) {
      alert('Please fill in all required fields.');
      return;
    }
    setCategories([...categories, { ...newCategory, id: categories.length + 1, status: 'Active' }]);
    handleClose();
  };

  // --- Edit Existing Category ---
  const handleEdit = (id) => {
    const categoryToEdit = categories.find(cat => cat.id === id);
    if (categoryToEdit) {
      setEditMode(true);
      setSelectedId(id);
      setNewCategory({
        name: categoryToEdit.name,
        logo: categoryToEdit.logo,
        seoName: categoryToEdit.seoName
      });
      setShowModal(true);
    }
  };

  // --- Save Edited Category ---
  const handleUpdateCategory = () => {
    if (!newCategory.name || !newCategory.seoName) {
      alert('Please fill in all required fields.');
      return;
    }
    setCategories(categories.map(cat =>
      cat.id === selectedId ? { ...cat, ...newCategory } : cat
    ));
    handleClose();
  };

  // --- Delete Category ---
  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      setCategories(categories.filter(cat => cat.id !== id));
    }
  };

  return (
    <Container fluid className="mt-4">
      <h2>Manage Category</h2>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Form.Control
          type="text"
          placeholder="Search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: '300px' }}
        />
        <Button variant="primary" onClick={handleShow}>
          Add Main Category
        </Button>
      </div>

      <div className="table-container" style={{ fontSize: "14px" }}>
        <Table bordered hover responsive>
          <thead className="custom-thead">
            <tr>
              <th>SL NO.</th>
              <th>Main Category Name</th>
              <th>Main Category Logo</th>
              <th>SEO Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentCategories.length ? (
              currentCategories.map((cat, idx) => (
                <tr key={cat.id} className={idx % 2 === 0 ? 'even-row' : 'odd-row'}>
                  <td>{startIndex + idx + 1}</td>
                  <td>{cat.name}</td>
                  <td>{cat.logo ? (typeof cat.logo === 'string' ? <img src={cat.logo} alt={cat.name} style={{ width: '50px' }} /> : cat.logo.name) : 'No Logo'}</td>
                  <td>{cat.seoName}</td>
                  <td>
                    <Button
                     variant="outline-primary"
                      size="sm"
                      className="me-2"
                      onClick={() => handleEdit(cat.id)}
                    >
                      <FiEdit />
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete(cat.id)}
                    >
                      <RiDeleteBin6Line />
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">No categories found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Pagination className="justify-content-center mt-3">
        <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1} />
        {[...Array(totalPages)].map((_, idx) => (
          <Pagination.Item
            key={idx + 1}
            active={currentPage === idx + 1}
            onClick={() => setCurrentPage(idx + 1)}
          >
            {idx + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>

      {/* Add / Edit Modal */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? 'Edit Main Category' : 'Add Main Category'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="categoryName">
              <Form.Label>Main Category Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Main Category Name"
                name="name"
                value={newCategory.name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="categoryLogo">
              <Form.Label>Main Category Logo</Form.Label>
              <Form.Control type="file" name="logo" onChange={handleChange} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="categorySEO">
              <Form.Label>Main Category SEO Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Main Category SEO Name"
                name="seoName"
                value={newCategory.seoName}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button
            variant="primary"
            onClick={editMode ? handleUpdateCategory : handleAddCategory}
          >
            {editMode ? 'Update Category' : 'Add Category'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
